import ListPageLayout from "../../componets/layout/ListPageLayout";
import equipmentApi from "../../services/equipmentApi";

export default function Equipment() {
    return(

        <ListPageLayout
            title={'Lista equipamentos'}
            urlCreate={'/equipamentos/formulario'}
            collunSearch={'nome'}
            table={
                {
                    loader: equipmentApi.all,
                    columns: [
                        { label: "Nome", index: "nome", type: 'string'},
                        { label: "Tipo", index: "tipo", type: 'string'},
                        { label: "Valor", index: "valor", type: 'value'},
                    ]
                }
            }
        />
    )
}